window.linkAppConfig = {
  ENVIRONMENT: "#{environment}#",
  PORTAL_URL: "#{portalUrl}#",
  LINK_API_URL: "#{linkApiUrl}#",
  LINK_SDK_URL: "#{linkSdkUrl}#",
  PUBLIC_API_URL: "#{publicApiUrl}#",
  GA_TRACKING_ID: "#{gaTrackingId}#",
  AMPLITUDE_API_KEY: "#{amplitudeApiKey}#",
};
